var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "field is-horizontal" }, [
    _c("div", { staticClass: "field-label", class: _vm.labelClasses }, [
      _c("label", { staticClass: "label" }, [_vm._t("label")], 2)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-body" }, [
      _c("div", { staticClass: "field" }, [
        _c("div", { staticClass: "control" }, [_vm._t("body")], 2)
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a96dd2b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a96dd2b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/HorizontalInput.vue
// module id = null
// module chunks = 